import moment from "moment";
import toformat from 'toformat';
import decimal from 'decimal.js/decimal';

const numeral = require('numeral');
const Decimal = toformat(decimal);

export function dateFormate(dateString, lang){
    const date = moment(dateString)
    if(!dateString || !date.isValid())  return dateString

   return lang === 'en' ? date.format('LL') : date.format('YYYY-MM-DD')
}

export function numberFormat(number, lang) {
  const v = new Decimal(number);
  return `${v.div(100000000).toFormat(2, 1)}${lang == 'zh' ? '（亿元）' : '（CNY100M）'}`;
}

export function numberFormat2(number, lang) {
  const v = new Decimal(number);
  if(lang == 'en') {
    return `${v.div(1000000).toFormat(2, 1)}（M Shares）`;
  }
  return `${v.div(10000).toFormat(2, 1)}（万手）`;
}